import clsx from 'clsx'
import { Outlet, useLocation } from 'react-router-dom'

import { ReactComponent as Logo } from '../../../assets/svgs/logo.svg'

export const Root = () => {
  const { pathname } = useLocation()

  return (
    <div
      className={clsx('w-full grow bg-none', {
        'lg:bg-wallpaper-auth lg:bg-no-repeat lg:bg-cover lg:bg-fixed':
          pathname !== '/expert/register/terms',
      })}
    >
      <header className="container flex items-center px-6 py-4 lg:py-0 mx-auto min-h-">
        {
          <Logo
            className={clsx('h-auto', {
              'w-24 lg:w-0': pathname !== '/expert/register/terms',
              'w-24': pathname === '/expert/register/terms',
            })}
          />
        }
      </header>

      <main className="container flex flex-col mx-auto grow">
        <Outlet />
      </main>
    </div>
  )
}
